import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gamerecord-form-erleger',
  templateUrl: './gamerecord-form-erleger.component.html',
  styleUrls: ['./gamerecord-form-erleger.component.css']
})
export class GamerecordFormErlegerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
